import { InputItem } from '../model.js';

export const getStatusFilters = (
  statuses: string[],
  includeAll = true
): InputItem[] => {
  const filters: InputItem[] = statuses.map((status) => {
    const val = getStatusValue(status);
    return { ...val, selected: false };
  });
  if (includeAll) {
    filters.unshift({
      id: '',
      value: 'All',
      selected: true,
      isDefault: true,
    });
  }
  return filters;
};

const getStatusValue = (status: string): { id: string; value: string } => {
  const result = { id: status, value: status };
  switch (status) {
    case 'SubmittedByCustomer':
      result.value = 'To be accepted';
      break;
    case 'Approved':
      result.value = 'To be billed';
      break;
    case 'WaitingForCNF':
      result.value = 'Waiting For CNF';
      break;
    case 'AddingItems':
      result.value = 'Draft';
      break;
    case 'PD':
      result.value = 'Paid';
      break;
    case 'P':
      result.value = 'Pending';
      break;
    case 'PP':
      result.value = 'Partially paid';
      break;
    case 'C':
      result.value = 'Cancelled';
      break;
    case 'OD':
      result.value = 'Over due';
      break;
    case 'UD':
      result.value = 'Un paid';
      break;
    case 'LIST':
      result.value = 'One Frame';
      break;
    case 'GALLERY':
      result.value = 'Carousel';
      break;
    default:
      break;
  }
  return result;
};
